import React from "react";
import star from "../../assets/images/stars.svg";
import stargray from "../../assets/images/starsgray.svg";
// import graystar from "../../assets/images/";

const StarRating = ({ filledStars }) => {
  const totalStars = 5;
  const stars = Array(totalStars)
    .fill("filled", 0, filledStars)
    .fill("empty", filledStars);
  return (
    <div className="star-rating d-flex gap-1">
      {stars?.map((type, index) => (
        <img
          key={index}
          src={type === "filled" ? star : stargray}
          alt={type === "filled" ? "filled star" : "empty star"}
        />
      ))}
    </div>
  );
};

export default StarRating;
